export default __webpack_public_path__ + "static/media/slider-Close.442e5fc2.svg";